import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconJourneyLogoPlain(props: IconProps) {
  return (
    <BaseIcon viewBox="0 0 74 74" {...props}>
      <path
        d="M17.6451 0C22.8598 4.43626 29.6174 7.11324 37.0003 7.11324C44.3831 7.11324 51.1407 4.43628 56.3554 5.02189e-05L63.417 7.06168C56.3851 13.2925 47.1344 17.0755 37.0003 17.0755C26.866 17.0755 17.6154 13.2925 10.5835 7.06163L17.6451 0Z"
        fill="currentColor"
      />
      <path
        d="M56.3554 74C51.1407 69.5637 44.3831 66.8868 37.0002 66.8868C29.6174 66.8868 22.8598 69.5637 17.6451 73.9999L10.5835 66.9383C17.6154 60.7075 26.8661 56.9245 37.0002 56.9245C47.1344 56.9245 56.3851 60.7075 63.417 66.9384L56.3554 74Z"
        fill="currentColor"
      />
      <path
        d="M0 56.3552C4.43626 51.1405 7.11324 44.3829 7.11324 37C7.11324 29.6171 4.43627 22.8595 4.85268e-05 17.6449L7.06168 10.5832C13.2925 17.6152 17.0755 26.8658 17.0755 37C17.0755 47.1342 13.2925 56.3848 7.06163 63.4168L0 56.3552Z"
        fill="currentColor"
      />
      <path
        d="M74 17.6448C69.5637 22.8595 66.8868 29.6171 66.8868 37C66.8868 44.3829 69.5637 51.1405 73.9999 56.3551L66.9383 63.4168C60.7075 56.3848 56.9245 47.1342 56.9245 37C56.9245 26.8658 60.7075 17.6152 66.9384 10.5832L74 17.6448Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
